import React, { useState, useMemo } from "react";
import {
  AdminContentContainer,
  AdminContentTitle,
  AdminUserHistoryContent,
  AdminContentSearchContainer,
  AdminContentSearchInputUser,
  NoResults,
  AdminUserHistoryList,
  AdminUserHistoryItem,
  Card,
  CardContent,
  CardText,
  ScrollableList,
} from '../styles';
import { Spinner } from ".";
import { adminGetBookingHistory } from "../api";

const UserHistory = ({ allUsers }) => {
  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const sortedUsers = useMemo(() => {
    if (!allUsers?.user?.users) return [];

    return [...allUsers.user.users].sort((a, b) =>
      a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' })
    );
  }, [allUsers]);

  const filteredUsers = useMemo(() => {
    if (!search) return sortedUsers;

    const searchLower = search.toLowerCase();

    return sortedUsers.filter(user =>
      user.nome.toLowerCase().includes(searchLower)
    );
  }, [search, sortedUsers]);

  const fetchHistory = async (username) => {
    try {
      setLoading(true);

      const response = await adminGetBookingHistory(username);
      
      if (!response.ok) {
        throw new Error('Erro ao buscar histórico');
      }
      
      const data = await response.json();

      setHistory(data || []);

    } catch (error) {
      console.error("Erro ao buscar histórico:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserClick = (username) => {
    setSelectedUser(username);
    fetchHistory(username);
  };

  return (
    <AdminContentContainer>
      <AdminContentTitle>Estatísticas de Usuários</AdminContentTitle>
      {/* Campo de busca */}
      <AdminContentSearchContainer>
        <AdminContentSearchInputUser
          type="text"
          placeholder="Buscar usuário pelo nome..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </AdminContentSearchContainer>
      <AdminUserHistoryContent>
        <AdminUserHistoryList>
          <AdminContentTitle>Usuários</AdminContentTitle>
          <ScrollableList>
            {filteredUsers.map((user) => (
              <AdminUserHistoryItem
                key={user.username}
                onClick={() => handleUserClick(user.username)}
                isSelected={selectedUser === user.username}
              >
                {user.nome}
              </AdminUserHistoryItem>
            ))}

            {!filteredUsers.length && search && (
              <NoResults>Nenhum usuário encontrado</NoResults>
            )}
          </ScrollableList>
        </AdminUserHistoryList>

        <AdminUserHistoryList>
          <AdminContentTitle>Histórico</AdminContentTitle>
          {selectedUser ? (
            <>
              {loading ? (
                <Spinner />
              ) : (
                <ScrollableList>
                  {history.length > 0 ? (
                    history.map((item, index) => (
                      <Card key={index}>
                        <CardContent>
                          <CardText><strong>Data:</strong> {item.date}</CardText>
                          <CardText><strong>Início:</strong> {item.start_time} | <strong>Fim:</strong> {item.end_time}</CardText>
                          <CardText><strong>Tipo de Reserva:</strong> {item.type === 'fixed' ? 'Reserva Mensal' : 'Reserva Avulsa'}</CardText>
                          <CardText><strong>Status da Reserva:</strong> {item.status}</CardText>
                        </CardContent>
                      </Card>
                    ))
                  ) : (
                    <NoResults>Sem marcações para este usuário.</NoResults>
                  )}
                </ScrollableList>
              )}
            </>
          ) : (
            <NoResults>Selecione um usuário para ver o histórico.</NoResults>
          )}
        </AdminUserHistoryList>
      </AdminUserHistoryContent>
    </AdminContentContainer>
  );
};

export default UserHistory;
